import React, { FC } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'
import { styled } from '@creditas/stylitas'
import { Filter as CreditasFilter } from '@creditas/filter'

import {
  APPROVAL,
  DOCS,
  EMISSION,
  NEW_CONTRACT,
  CONTRACT_SENT,
  INCOME,
  RELEASE,
} from 'utils/constantFilter'

import { StatusFilter } from './StatusFilter'

const Filter = styled(CreditasFilter)`
  margin: 8px 4px;
`

const GroupStatusFilter: FC<{ assignments?: Workflow[] }> = ({
  assignments,
}) => {
  const [filter, setFilter] = useQueryParam('filter', StringParam)

  const handleFilter = (field: string) => {
    if (filter === field) {
      setFilter(undefined)
    } else {
      setFilter(field)
    }
  }

  return (
    <>
      <Filter selected={!filter} onClick={() => setFilter(undefined)}>
        Todos ({assignments?.length || 0})
      </Filter>
      {[
        APPROVAL,
        DOCS,
        EMISSION,
        INCOME,
        NEW_CONTRACT,
        CONTRACT_SENT,
        RELEASE,
      ].map(pipelineStatus => (
        <StatusFilter
          key={pipelineStatus}
          assignments={assignments}
          active={filter === pipelineStatus}
          handleClick={() => handleFilter(pipelineStatus)}
          pipelineStatus={pipelineStatus}
        />
      ))}
    </>
  )
}

export { GroupStatusFilter as StatusFilter }
